<template>
  <div>
    <terc-picker :model="schema" :field="tercField" :row="row"></terc-picker>

    <simc-picker :model="schema" :field="simcField" :terc="schema.terc.$value"></simc-picker>

    <ulic-picker :model="schema" :field="ulicField" :required="required" :terc="schema.terc.$value" :simc="schema.simc.$value"></ulic-picker>
  </div>
</template>

<script>
import TercPicker from './TERCPicker';
import SimcPicker from './SIMCPicker';
import UlicPicker from './ULICPicker';

// @vuese
// Komponent formularza TERYT
// @group Components/Forms
export default {
  components: { TercPicker, SimcPicker, UlicPicker },
  props: {
    // Schema
    schema: {
      type: Object,
      required: true
    },
    // Nazwa pola z TERC-em
    tercField: {
      type: String,
      required: false,
      default: 'terc'
    },
    // Nazwa pola z SIMC-em
    simcField: {
      type: String,
      required: false,
      default: 'simc'
    },
    // Nazwa pola z ULIC-em
    ulicField: {
      type: String,
      required: false,
      default: 'ulic'
    },
    // Czy pola mają być ustawione rzędami
    row: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy pola są wymagane
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
